import {
  showErrorMessage,
  attachRecaptchaToken,
  checkStatus,
  createRequest,
  isKFDomain,
  parseJSON
} from "./utils";
import { Queue } from "./queue";

export const sendPublicRequest = (url, options) => {
  let headerOptions = options;
  let controller = new AbortController();
  options.signal = controller.signal;
  let promise = async function creatingRequest() {
    if (isKFDomain(url)) {
      headerOptions = await attachRecaptchaToken(options);
    }
    let request = await createRequest(url, headerOptions);
    return fetch(request)
      .then(checkStatus)
      .then(parseJSON)
      .catch((err) => {
        if (options.method !== "GET") {
          let showToast = options.hasOwnProperty("toast")
            ? options.toast
            : true;
          showToast && showErrorMessage(err);
        }
        return Promise.reject(err);
      });
  };
  return [promise, () => controller.abort()];
};

export const PublicService = {
  get(url, options = {}) {
    options.method = "GET";
    return sendPublicRequest(url, options);
  },
  post(url, options = {}) {
    options.method = options.method || "POST";
    return sendPublicRequest(url, options);
  },
  update: function updateService(url, options = {}) {
    options.method = "PUT";
    return this.post(url, options);
  },
  patch(url, options = {}) {
    options.method = "PATCH";
    return sendPublicRequest(url, options);
  },
  delete(url, options = {}) {
    options.method = "DELETE";
    return sendPublicRequest(url, options);
  },
  postq(url, options = {}, callback = () => false, queueName = "default") {
    let queue = Queue.getQueue(queueName, true);
    options.method = "POST";
    return queue.queueRequest(url, options, callback);
  },
  fetch: (url, options = {}) => {
    options = Object.assign({ method: "GET" }, options);
    let request = createRequest(url, options);
    return fetch(request).then(checkStatus);
  },
  async upload(url, options = {}) {
    if (isKFDomain(url)) {
      options = await attachRecaptchaToken(options);
    }
    let request = createRequest(url, options);
    return fetch(request)
      .then(checkStatus)
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  download: async (url, options = {}) => {
    if (isKFDomain(url)) {
      options = await attachRecaptchaToken(options);
      if (!options.headers) {
        options.headers = {};
      }
      options.headers.redirect = "follow";
    }
    let request = await createRequest(url, options);
    return fetch(request)
      .then(checkStatus)
      .then((response) => response.blob())
      .catch((err) => {
        return Promise.reject(err);
      });
  }
};
